<template>
  <div id="mapa-serwisu">
    <T1HeadScripts rodzajstrony="mapaserwisu" />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <div class="container" id="t1content">
        <a-layout-content>
          <T1MapaSerwisuContent />
        </a-layout-content>
      </div>
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1MapaSerwisuContent from "./components/T1MapaSerwisuContent";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "mapa-serwisu",
  data: () => ({}),
  methods: {},
  mounted() {},
  components: {
    T1HeadScripts,
    T1Header,
    T1MapaSerwisuContent,
    T1Footer
  }
};
</script>
